module.exports = __webpack_public_path__ + "img/biaozhun-dingdan.67187195.svg";